<template>
  <div class="subject">
    <div class="topTitle"><span @click="goback">返回</span> / {{ difficultyId ? '编辑问题' : '新增问题' }}</div>
    <!-- <math xmlns="http://www.w3.org/1998/Math/MathML">
      <msqrt>
        <mn>104</mn>
      </msqrt>
    </math> -->

    <div class="table">
      <div style="overflow: hidden;">
        <div class="fl">问题列表</div>

        <div class="fr">
          <div>
            <el-switch v-model="value1" active-value="2" inactive-value="1" active-text="Markdown" inactive-text="富文本">
            </el-switch>
          </div>
        </div>
      </div>
      <el-divider></el-divider>

      <el-form ref="problem" :model="problem" :rules="rules" label-position="top" label-width="70px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item prop="sort_num" label="排序号">
              <el-input-number v-model="problem.sort_num" :precision="1" :step="0.1"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="code" label="试题编号" required>
              <el-input placeholder="试题编号" v-model="problem.code" maxlength="200" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="title" label="题目名称" required>
              <el-input placeholder="题目名称" v-model="problem.title" maxlength="200" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="isShowRichtext">
          <el-col :span="24">
            <el-form-item prop="description" label="描述" required>
              <Tinymce v-if="isReloadData" v-model="problem.description"></Tinymce>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="input_description" label="输入描述" required>
              <Tinymce v-if="isReloadData" v-model="problem.input_description"></Tinymce>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="output_description" label="输出描述" required>
              <Tinymce v-if="isReloadData" v-model="problem.output_description"></Tinymce>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item style="margin-top: 20px" label="提示">
              <Tinymce v-if="isReloadData" v-model="problem.hint" placeholder=""></Tinymce>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="isShowMarkDown">
          <el-col :span="24">
            <el-form-item prop="" label="问题描述">
              <markdownShow v-if="showmarkdown" @changeMardown="changeMardown" :markdown="problem.markdown_explain" @SaveMarkDown="SaveMarkDown">
              </markdownShow>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="" label="输入描述">
              <markdownShow v-if="showmarkdown1" @changeMardown="changeMardown1" :markdown="problem.md_input_description" @SaveMarkDown="SaveMarkDown1">
              </markdownShow>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="" label="输出描述">
              <markdownShow v-if="showmarkdown2" @changeMardown="changeMardown2" :markdown="problem.md_output_description" @SaveMarkDown="SaveMarkDown2">
              </markdownShow>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="" label="提示">
              <markdownShow v-if="showmarkdown3" @changeMardown="changeMardown3" :markdown="problem.md_hint" @SaveMarkDown="SaveMarkDown3">
              </markdownShow>
            </el-form-item>
          </el-col>
        </el-row>
        <div>
          <el-form-item v-for="(item, index) in problem.samples" :key="index">
            <el-card>
              <div slot="header" class="clearfix">
                <span>{{ "samples" + (index + 1) }}</span>
                <el-button type="warning" size="small" style="float: right" icon="el-icon-delete" slot="header" @click="deleteSample(index)">
                  Delete
                </el-button>
              </div>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="输入样式" required>
                    <el-input :rows="5" type="textarea" placeholder="输入样式" v-model="item.input">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="输出样式" required>
                    <el-input :rows="5" type="textarea" placeholder="输出样式" v-model="item.output">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
          </el-form-item>
        </div>
        <div class="add-sample-btn">
          <button type="button" class="add-samples" @click="addSample">
            <i class="el-icon-plus"></i>添加样式
          </button>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item prop="" label="附件">
              <el-upload action="" :http-request="uploadFile1" :on-remove="handleRemove1" :on-change="handleChangeFile1" :auto-upload="false" :limit="1" :file-list="problem.fileList1" style="width: 400px">
                <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
              </el-upload>
            </el-form-item>

          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="时间限制(ms)" required>
              <el-input type="Number" v-model="problem.time_limit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="内存限制(MB)" required>
              <el-input type="Number" v-model="problem.memory_limit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="难度">
              <el-select class="difficulty-select" size="small" v-model="problem.oj_problem_difficulty_id" style="width: 100%">
                <el-option v-for="item in difficultyList" :key="item.id" :label="item.title" :value="item.id">
                </el-option>
                <!-- <el-option label="低" :value="1"></el-option>
                <el-option label="中" :value="2"></el-option>
                <el-option label="高" :value="3"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <!-- <el-col :span="8">
            <el-form-item label=" 知识点标签">
              <el-select class="difficulty-select" size="small" v-model="problem.difficulty" style="width:100%">
                <el-option label="低" :value="1"></el-option>
                <el-option label="中" :value="2"></el-option>
                <el-option label="高" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label=" 问题来源标签">
              <el-select class="difficulty-select" size="small" v-model="problem.oj_problem_source_id" style="width: 100%">
                <el-option v-for="item in problemList" :key="item.id" :label="item.title" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="算法标签">
              <el-select class="difficulty-select" @change="$forceUpdate()" size="small" v-model="problem.tagIdArr" multiple filterable style="width: 100%">
                <el-option v-for="item in tagIdArrList" :key="item.id" :label="item.title" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="8">
            <el-form-item label="计分模式">
              <el-radio v-model="problem.rule_type" :label="1">不显示分数(ACM赛制)</el-radio>
              <el-radio v-model="problem.rule_type" :label="2">显示分数(OI模式)</el-radio>
            </el-form-item>
          </el-col> -->

          <!-- <el-col :span="8">
            <el-form-item label="IO MODE">
              <el-radio v-model="problem.io_mode" :label="2">标准IO</el-radio>
              <el-radio v-model="problem.io_mode" :label="1">文件IO</el-radio>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="可选编程语言" required>
              <el-checkbox-group v-model="problem.languages" @change="languagesChange">
                <el-checkbox v-for="item in languagess" :label="item.id" :key="item.id">{{ item.name }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="是否可见">
              <el-radio v-model="problem.visible" label="0">不可见</el-radio>
              <el-radio v-model="problem.visible" label="1">可见</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="提交结果是否公开">
              <el-radio v-model="problem.share_submission" label="0">不公开</el-radio>
              <el-radio v-model="problem.share_submission" label="1">公开</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="$route.query.type === 'Game' ? true : false">
            <el-form-item label="比赛是否公开">
              <el-radio v-model="problem.is_public" label="0">不公开</el-radio>
              <el-radio v-model="problem.is_public" label="1">公开</el-radio>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="代码模板">
          <el-row>
            <el-col :span="24" v-for="(v, k) in codeTemplate" :key="'template' + k">
              <el-form-item>
                <el-checkbox v-model="v.checked">{{ v.name }}</el-checkbox>
                <div v-if="v.checked">
                  <code-mirror v-model="v.config.template" :mode="v.content_type"></code-mirror>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="Special Judge">
          <el-col :span="21">
            <el-checkbox v-model="problem.spj" @change="spjBtn">Special Judge</el-checkbox>
            <!-- <el-radio v-model="problem.spj" @change="spjBtn" label="0">Special Judge</el-radio> -->
          </el-col>
          <el-col :span="3">
            <el-button round size="mini" @click="showDialogVisible">Special Judge 示例</el-button>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-card title="Special Judge" v-if="isShow">
            <template slot="header">
              <span>Special Judge</span>
              <div class="fr">
                <el-radio-group v-model="problem.spj_language">
                  <el-tooltip class="spj-radio" v-for="lang in allLanguage" :key="lang.name" effect="dark" :content="lang.name" placement="top-start">
                    <el-radio :label="lang.id">{{ lang.name }}</el-radio>
                  </el-tooltip>
                </el-radio-group>
                <el-button @click="compileSpj" style="margin-left: 20px" type="primary" size="small" icon="el-icon-fa-random" :loading="loadingCompile">
                  编译
                </el-button>
              </div>
            </template>
            <code-mirror v-model="problem.spj_code" :mode="spjMode"></code-mirror>
          </el-card>
        </el-form-item>
        <el-row :gutter="20" v-if="problem.rule_type === 2 ? false : true">
          <el-col :span="8">
            <el-form-item label="分值">
              <el-input placeholder="分值" v-model="problem.total_score"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 50px">
          <el-form-item label="测试用例">
            <el-upload v-if="isReloadData" action="" multiple :limit="1" :http-request="uploadFile" :on-exceed="handleExceed" :show-file-list="true" :file-list="fileList" style="display: inline-block; margin: 0 10px" :on-remove="handleRemove">
              <el-button size="small" type="success" icon="el-icon-upload">读取压缩包</el-button>
            </el-upload>
            <!-- 
            <el-upload action ref="upload" multiple :http-request="uploadFile" :before-upload="handleBefore" :auto-upload="false" :on-remove="handleRemove" :on-change="handleChangeFile" :on-exceed="handleExceed" :file-list="fileList" style="width: 400px">
              <el-button size="small" type="primary" plain>上传文件</el-button>
            
            </el-upload> -->
          </el-form-item>
        </el-row>
        <el-row style="margin-bottom: 50px" v-if="isshouw1">
          <el-table row-key="input_name" :data="tableData1" style="width: 100%" ref="sortableTable">
            <el-table-column prop="input_name" label="Input"> </el-table-column>
            <el-table-column prop="output_name" label="Output">
            </el-table-column>
            <el-table-column prop="score" label="Score">
              <template slot-scope="scope">
                <span v-if="isrule_type === 2">
                  <el-input v-model="scope.row.score" @input="$forceUpdate()" type="text"></el-input>
                </span>
                <span v-else>{{ scope.row.score }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="操作" v-if="isdrag">
              <template>
                <i class="el-icon-rank" style="margin-left:20px; cursor: pointer;"></i>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-button v-if="isShow1" @click="saveGame('problem')">SaveGam</el-button>
        <el-button v-if="isShow2" @click="save('problem')">Save</el-button>
        <!-- <el-button @click="sc">sc</el-button> -->
      </el-form>
    </div>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="80%">
      <span style='white-space:pre-line;'>{{ txt }}</span>
      <div>
        /*<br />
        parameter: <br />
        - input，标程输入的文件指针<br />
        - user_output，用户输出文件的指针<br />
        return:<br />
        - 如果用户答案正确，返回AC<br />
        - 如果用户答案错误返回WA<br />
        - 如果主动捕获到自己的错误，如内存分配失败，返回ERROR<br />
        请用户完成此函数.<br />
        demo:<br />
        int a, b;<br />
        while(fscanf(input, "%d %d", &a, &b) != EOF){<br />
        if(a -b != 3){<br />
        return WA;<br />
        }<br />
        }<br />
        return AC;<br />
        */<br />
        }<br />

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
<script>
import Sortable from "sortablejs";

import uploadFile1 from "@/config/uploadFile";

import Tinymce from "@/components/Tinymce";
import CodeMirror from "@/components/CodeMirror";
import uploadFileBlob from "@/config/uploadFileBlobForTestcase";

const JSZip = require("jszip");
const uuid = require("uuid");
import md5 from 'js-md5';
import markdownShow from "@/components/markdownShow";



import {
  adminGetOjProblemTagList,
  adminGetOjProblemSourceList,
  adminAddOrUpdateOjProblem,
  adminAddProblemForContest,
  adminGetOjProblemDifficultyList,
  adminGetOjProblemInfoById,
  compileSpj

} from "@/api/adminOj.js";

export default {
  components: {
    Tinymce,
    CodeMirror,
    markdownShow: markdownShow,


  },
  data() {
    return {
      zipEntryName: null,
      jsonStrObj: {},
      base64File: null,
      showmarkdown: true,
      showmarkdown1: true,
      showmarkdown2: true,
      showmarkdown3: true,

      value1: null,


      txt:
        '#include <stdio.h> \n' +
        "#define AC 0 \n" +
        "#define WA 1 \n" +
        "#define ERROR -1 \n" +

        "int spj(FILE *input, FILE *user_output); \n" +

        "void close_file(FILE *f){ \n" +
        "\xa0\xa0\xa0\xa0\xa0if(f != NULL){ \n" +
        "\xa0\xa0\xa0\xa0\xa0\xa0fclose(f); \n" +
        '\xa0\xa0\xa0\xa0\xa0} \n' +
        "} \n" +

        "int main(int argc, char *args[]){ \n" +
        "FILE *input = NULL, *user_output = NULL; \n" +
        "\xa0\xa0int result; \n" +
        "\xa0\xa0if(argc != 3){ \n" +
        '\xa0\xa0printf("Usage: spj x.in x.out\n"); \n' +
        '\xa0\xa0return ERROR; \n' +
        "\xa0\xa0} \n" +
        '\xa0input = fopen(args[1], "r"); \n' +
        '\xa0ser_output = fopen(args[2], "r"); \n' +
        '\xa0if(input == NULL || user_output == NULL){ \n' +
        '\xa0\xa0printf("Failed to open output file\n"); \n' +
        "\xa0\xa0close_file(input); \n" +
        "\xa0\xa0close_file(user_output); \n" +
        "\xa0\xa0return ERROR; \n" +
        "\xa0\xa0} \n" +

        "\xa0\xa0result = spj(input, user_output); \n" +
        '\xa0\xa0printf("result: %d\n", result); \n' +

        '\xa0\xa0close_file(input); \n' +
        '\xa0\xa0close_file(user_output); \n' +
        " \xa0\xa0return result; \n" +
        "}, \n" +
        "/*************************** 以上内容请勿修改！！！ ***********************/ \n" +
        "/*************************** 请在下面的spj函数体内编写特判逻辑！ ***********************/ \n" +
        'int spj(FILE *input, FILE *user_output){ \n',
      dialogVisible: false,
      isShowMarkDown: false,
      isdrag: false,
      isShowRichtext: false,
      isshouw1: true,
      isReloadData: true,
      spj_code1: '',
      spjVersion: '',
      outList: [],
      outNum: [],
      isshowTable: true,
      isrule_type: 1,
      isShow1: false,
      isShow2: true,
      template1: {},

      contest_id: "",
      difficultyId: "",
      spj: "0",
      num: null,
      uploadParams: [],
      fileList: [],

      isShow: false,
      tableData: [],
      tableData1: [],
      template: {},

      form1: {},
      loadingCompile: false,
      rules: {
        code: { required: true, message: "请输入试题编号", trigger: "blur" },
        title: { required: true, message: "请输入题目名称", trigger: "blur" },
        description: { required: true, message: "请输入描述", trigger: "blur" },
        input_description: {
          required: true,
          message: "请输入输入数据",
          trigger: "blur",
        },
        output_description: {
          required: true,
          message: "请输入输出数据",
          trigger: "blur",
        },
        sort_num: [
          {
            required: true,
            message: "请输入排序号",
            trigger: "change",
          },
          {
            required: true,
            message: "请输入排序号",
            trigger: "blur",
          },
        ],
      },
      //添加标签
      inputVisible: false,
      inputValue: "",
      spjMode: "",
      files: null,

      problem_testcase_id: "",

      problem: {
        fileList1: [],
        markdown_explain: '',
        md_input_description: '',
        md_output_description: '',
        md_hint: '',
        hint: '',
        spj_language: 0,
        template: {},
        memory_limit: 128,
        time_limit: 1000,
        samples: [{ input: "", output: "" }],
        tagIdArr: [],
        sort_num: 0,
        share_submission: "1",
        is_public: "1",
        io_mode: 2,
        rule_type: 1,
        test_case_score: [],
        test_case_id: "",
        total_score: 100,
        spj1: false,
        dynamicTags: [],
        visible: "1",
        languages: ["0", "1", "2"],

        codeTemplates: [],
      },
      allLanguage: [
        {
          name: "c",
          id: 0,
        },
        {
          name: "c++",
          id: 1,
        },
      ],
      //问题来源
      problemList: [],
      difficultyList: [],
      isShowinfo: false,
      //算法标签列表
      tagIdArrList: [],
      //可选编程语言
      languagess: [
        {
          id: '0',
          name: 'C'
        },
        {
          id: '1',
          name: 'C++'
        },
        {
          id: '2',
          name: 'Python3'
        }
      ],
      codeTemplate: [
        {
          checked: false,
          id: "0",
          name: "C",
          content_type: "text/x-c++src",
          config: {
            template: "//PREPEND BEGIN\n//PREPEND END\n//TEMPLATE BEGIN\n//TEMPLATE END\n//APPEND BEGIN\n//APPEND END",
          },
        },
        {
          checked: false,
          id: "1",
          name: "C++",
          content_type: "text/x-c++src",
          config: {
            template: "//PREPEND BEGIN\n//PREPEND END\n//TEMPLATE BEGIN\n//TEMPLATE END\n//APPEND BEGIN\n//APPEND END",

          },
        },
        {
          checked: false,
          id: "2",
          name: "Python3",
          content_type: "text/x-c++src",
          config: {
            template: "//PREPEND BEGIN\n//PREPEND END\n//TEMPLATE BEGIN\n//TEMPLATE END\n//APPEND BEGIN\n//APPEND END",

          },
        },
      ],
    };
  },
  watch: {

    tableData1: {
      handler(newVal) {
        if (newVal.length > 0) {
          console.log(123456)
          this.$nextTick(() => {
            setTimeout(() => {
              this.rowDrop()
            }, 500);
          })
        }

      },
      deep: true  // 深度监听tableData的变化
    },
    value1(val) {
      if (val === '1') {
        this.isShowRichtext = true
        this.isShowMarkDown = false

      } else if (val === '2') {
        this.isShowMarkDown = true
        this.isShowRichtext = false
        this.showmarkdown = false
        this.showmarkdown1 = false
        this.showmarkdown2 = false
        this.showmarkdown3 = false
        this.$nextTick(() => {
          this.showmarkdown3 = true
          this.$nextTick(() => {
            this.showmarkdown2 = true
            this.$nextTick(() => {
              this.showmarkdown1 = true
              this.$nextTick(() => {
                this.showmarkdown = true
              })
            })
          })
        })
        // this.$nextTick(() => {
        //   document.getElementById("sub").scrollIntoView();
        // })
      }
    },


    // newArr: {
    //   handler: function (val) {
    //     let bojList = {}
    //     val.map((item) => {
    //       if (item.checked === true) {
    //         bojList[item.id] = item.config.template
    //       }
    //     })
    //     // console.log(bojList, 123465798)
    //     this.template1 = bojList
    //   },
    //   deep: true
    // },
    codeTemplate: {

      handler(newVal) {
        console.log(newVal, 777888881);
        let bojList = {}
        newVal.map((item) => {
          if (item.checked === true) {
            bojList[item.id] = item.config.template
          }
        })
        console.log(bojList, 777888881)
        this.template1 = bojList
      },
      deep: true, // 加这个属性，深度监听
    },



    "problem.rule_type"(val) {
      this.isrule_type = 1;

      this.isrule_type = val;

      console.log(this.isrule_type);

    },

    'problem.spj_code'(val) {
      if (this.$route.query != null) {
        if (this.spj_code1 === val) {
          this.spjVersion = this.problem.spj_version
          console.log(this.spjVersion)
        } else {
          this.spjVersion = ''
          console.log(this.spjVersion)
        }
      }
    },
    numTotal1: {
      handler: function () {

        var that = this;
        if (that.isrule_type === 1) {

          console.log(that.numTotal1, 111)
          let numTotal = 0
          that.isshouw1 = false

          that.tableData1.map((item) => {
            item.score = that.numTotal1
            numTotal += item.score
          })
          that.$nextTick(() => {
            that.isshouw1 = true
          })
          if (this.problem.total_score - numTotal < 0) {
            var end = this.tableData1[this.tableData1.length - 1];
            let end1 = parseInt(end.score) + (this.problem.total_score - numTotal);
            end.score = end1;
          } else if (this.problem.total_score - numTotal > 0) {
            var end2 = this.tableData1[this.tableData1.length - 1];
            let end3 = parseInt(end2.score) + (this.problem.total_score - numTotal);
            end2.score = end3;
          }
        }
      }


    },
    numTotal: {
      handler: function () {
        var that = this;
        that.isshouw1 = false
        if (that.isrule_type === 2) {
          that.problem.total_score = that.numTotal;

        }
        that.$nextTick(() => {
          that.isshouw1 = true
        })
      }


    },
  },
  created() {
    console.log(this.$route.query.type, 12467)
    this.contest_id = this.$route.query.contest_id;
    if (this.$route.query.type === "Game") {
      this.isShow1 = true;
      this.isShow2 = false;
    } else {
      this.isShow1 = false;
      this.isShow2 = true;
    }


  },
  computed: {

    numTotal() {
      return this.tableData1
        .map((row) => row.score)
        .reduce((acc, cur) => parseFloat(cur) + acc, 0);
    },
    numTotal1() {
      return parseInt(parseInt(this.problem.total_score) / parseInt(this.tableData1.length))
    },
    // newArr: function () {
    //   return JSON.parse(JSON.stringify(this.codeTemplate))
    // }
  },
  mounted() {


    this.value1 = sessionStorage.getItem('isMarkDown1')
    console.log(this.value1, 121212);
    if (this.value1 === '1') {
      this.isShowRichtext = true
      this.isShowMarkDown = false
    } else if (this.value1 === '2') {
      this.isShowMarkDown = true
      this.isShowRichtext = false
    }


    // if (this.$route.query.addType === '2') {
    //   this.isShowMarkDown = true
    //   this.isShowRichtext = false
    // } else if (this.$route.query.addType === '1') {
    //   this.isShowMarkDown = false
    //   this.isShowRichtext = true
    // } else {

    // }

    this.adminGetOjProblemTagList();
    this.adminGetOjProblemSourceList();
    this.adminGetOjProblemDifficultyList();
    this.info();
    if (this.$route.query.row != null) {
      this.adminGetOjProblemInfoById()
    }
  },
  methods: {
    rowDrop() {
      // 要侦听拖拽响应的DOM对象
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const that = this;
      console.log(that.tableData1, 4547878);

      Sortable.create(tbody, {
        animation: 1000,
        ghostClass: "ghostClass", //设置拖拽停靠样式类名
        chosenClass: "chosenClass", //设置选中样式类名
        handle: ".el-icon-rank",
        // 结束拖拽后的回调函数
        onEnd({ newIndex, oldIndex }) {
          console.log("拖动了行，当前序号：" + newIndex);
          const currentRow = that.tableData1.splice(oldIndex, 1)[0];
          that.tableData1.splice(newIndex, 0, currentRow);
          console.log(that.tableData1, 4578);
        },
      });
    },
    uploadFile1() { },
    //上传
    handleRemove1(file, fileList) {
      console.log(file, fileList);
      this.problem.fileList1 = []
      this.problem.attachment_url = ''
    },
    async handleChangeFile1(file, fileList) {
      console.log("上传课程体系缩略图");
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status);
      }
    },

    async uploadFileOss(list) {
      this.uploadFileTime = true;
      await uploadFile1(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log("res");
          console.log(res, 2323232);
          this.problem.fileList1 = res
          this.problem.fileList1.map((item) => {
            this.problem.attachment_url = item.url
          })
          this.uploadFileTime = false;
        }
      );
    },
    changeMardown1(val) {
      this.problem.md_input_description = val

    },
    changeMardown2(val) {
      this.problem.md_output_description = val

    },
    changeMardown3(val) {
      this.problem.md_hint = val

    },
    changeMardown(val) {
      this.problem.markdown_explain = val

    },



    SaveMarkDown1(md, html) {
      console.log("保存markdown");
      console.log(md, 45412);
      console.log(html, 13223);
      this.problem.md_input_description = md;
    },
    SaveMarkDown2(md, html) {
      console.log("保存markdown");
      console.log(md, 45412);
      console.log(html, 13223);
      this.problem.md_output_description = md;
    },
    SaveMarkDown3(md, html) {
      console.log("保存markdown");
      console.log(md, 45412);
      console.log(html, 13223);
      this.problem.md_hint = md;
    },
    SaveMarkDown(md, html) {
      console.log("保存markdown");
      console.log(md, 45412);
      console.log(html, 13223);

      this.problem.markdown_explain = md;
      // this.ruleForm.html_explain = html;
    },
    reloadPart() {
      this.isReloadData = false
      this.$nextTick(() => {
        this.isReloadData = true


      })
    },
    // checkedChange() {

    //   let bojList = {}
    //   this.codeTemplate.map((item) => {
    //     console.log(item, 123465798)
    //     if (item.checked === true) {
    //       console.log(item.config.template, 123465798)
    //       bojList[item.id] = item.config.template
    //     }
    //   })
    //   console.log(bojList, 123465798)
    //   this.template1 = bojList
    // },
    changeLs(val) {
      console.log(val)
    },
    showDialogVisible() {
      this.dialogVisible = true
    },
    compileSpj() {
      compileSpj({
        spjCode: this.problem.spj_code,
        spjLanguage: this.problem.spj_language
      }).then((res) => {
        console.log(res, 123456)
        if (res.error === null) {
          this.spjVersion = res.spjVersion
          console.log(this.spjVersion)
          this.$message.success("编译成功");

        } else {
          this.$message.warning('编译失败')

        }


      })

    },

    adminGetOjProblemInfoById() {
      adminGetOjProblemInfoById({
        problem_id: this.$route.query.row
      }).then((res) => {

        console.log('编辑题目信息')
        console.log(res, 412121212);


        this.difficultyId = res.ojProblemInfo.id;
        this.problem_testcase_id = res.ojProblemInfo.test_case_id;
        this.showmarkdown = false
        this.showmarkdown1 = false
        this.showmarkdown2 = false
        this.showmarkdown3 = false




        this.$nextTick(() => {
          console.log(res.ojProblemInfo.attachment_url, 412121212);

          if (res.ojProblemInfo.attachment_url === null || res.ojProblemInfo.attachment_url === "") {
            this.problem.fileList1 = []

          } else {
            console.log(res.ojProblemInfo.attachment_url.split('/').slice(-1)[0].split('-').slice(-1)[0], 412121212);
            this.problem.fileList1 = []
            this.problem.fileList1.push({
              name: res.ojProblemInfo.attachment_url.split('/').slice(-1)[0].split('-').slice(-1)[0],
              url: res.ojProblemInfo.attachment_url
            })
          }
          if (res.ojProblemInfo.md_hint != null) {
            this.problem.md_hint = res.ojProblemInfo.md_hint
          } else {
            this.problem.md_hint = ''
          }
          this.showmarkdown3 = true
          this.$nextTick(() => {
            if (res.ojProblemInfo.md_output_description != null) {
              this.problem.md_output_description = res.ojProblemInfo.md_output_description
            } else {
              this.problem.md_output_description = ''

            }
            this.showmarkdown2 = true
            this.$nextTick(() => {
              if (res.ojProblemInfo.md_input_description != null) {
                this.problem.md_input_description = res.ojProblemInfo.md_input_description

              } else {
                this.problem.md_input_description = ''
              }
              this.showmarkdown1 = true
              this.$nextTick(() => {
                if (res.ojProblemInfo.md_description != null) {
                  this.problem.markdown_explain = res.ojProblemInfo.md_description
                } else {
                  this.problem.markdown_explain = ''
                }
                this.showmarkdown = true
              })

            })
          })

        })

        // this.$nextTick(() => {
        //   if (res.ojProblemInfo.md_input_description != null) {
        //     this.problem.md_input_description = res.ojProblemInfo.md_input_description

        //   } else {
        //     this.problem.md_input_description = ''

        //   }
        //   if (res.ojProblemInfo.md_output_description != null) {
        //     this.problem.md_output_description = res.ojProblemInfo.md_output_description

        //   } else {
        //     this.problem.md_output_description = ''

        //   }
        //   if (res.ojProblemInfo.md_hint != null) {
        //     this.problem.md_hint = res.ojProblemInfo.md_hint

        //   } else {
        //     this.problem.md_hint = ''

        //   }
        //   if (res.ojProblemInfo.md_description != null) {
        //     this.problem.markdown_explain = res.ojProblemInfo.md_description

        //   } else {
        //     this.problem.markdown_explain = ''

        //   }
        //   this.showmarkdown = true
        //   // this.$nextTick(() => {
        //   //   document.documentElement.scrollTop = 0
        //   //   // document.getElementById("sub").scrollIntoView();
        //   // })
        // })





        let problemTagIdArr1 = []
        // let arry = []
        this.problem = res.ojProblemInfo
        this.problem.hint = res.ojProblemInfo.hint
        this.problem.description = res.ojProblemInfo.description



        this.codeTemplate.map((item) => {
          for (var key in JSON.parse(res.ojProblemInfo.template)) {
            console.log(key, 78945613);        //键名
            console.log(JSON.parse(res.ojProblemInfo.template)[key], 78945613);        //键名
            if (item.id === key) {
              item.config.template = JSON.parse(res.ojProblemInfo.template)[key]
              item.checked = true
            }
          }
        })

        this.spj_code1 = res.ojProblemInfo.spj_code
        this.problem.problemTagArr.map((item) => {
          problemTagIdArr1.push(item.tagInfo.id)
        })
        this.problem.tagIdArr = problemTagIdArr1;
        this.problem.languages = JSON.parse(res.ojProblemInfo.languages)
        if (res.ojProblemInfo.visible === true) {
          this.problem.visible = '1'
        } else {
          this.problem.visible = '0'
        }
        if (res.ojProblemInfo.share_submission === true) {
          this.problem.share_submission = '1'
        } else {
          this.problem.share_submission = '0'
        }
        if (res.ojProblemInfo.is_public === true) {
          this.problem.is_public = '1'
        } else {
          this.problem.is_public = '0'
        }
        this.tableData1 = JSON.parse(res.ojProblemInfo.test_case_score)
        console.log(res.ojProblemInfo.test_case_score, 1463233);
        this.problem.samples = JSON.parse(res.ojProblemInfo.samples)
        // this.codeTemplate = JSON.parse(res.ojProblemInfo.template)

        if (res.ojProblemInfo.spj === true) {
          this.spj = '1'
        } else {
          this.spj = '0'
        }
        this.isShow = res.ojProblemInfo.spj
        this.problem.spj_language = JSON.parse(res.ojProblemInfo.spj_language)
        this.reloadPart()
      })
    },
    //获取难度标签
    adminGetOjProblemDifficultyList() {
      adminGetOjProblemDifficultyList({
        page_no: 1,
        page_size: 500,
      }).then((res) => {
        console.log(res);

        this.difficultyList = res.ojProblemDifficultyList;
      });
    },
    info() {
      this.isrule_type = 1;
    },
    saveGame(formName) {
      if (this.tableData1.length === 0) {
        this.$message.warning('测试用例不能为空')
        return false
      } else {
        if (this.isrule_type === 1) {
          this.tableData1.map((item) => {
            if (item.output_name === undefined) {
              this.$message.warning("请上传正确格式");
            }
          });
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.difficultyId) {
              let JsonSpj = {}
              var test_cases = {};

              var spj = this.spj === '0' ? false : true;

              this.tableData1.map((item, index) => {
                test_cases[index + 1] = item
              })
              JsonSpj.spj = spj
              JsonSpj.test_cases = test_cases

              console.log(JsonSpj, 124545)
              console.log(this.jsonStrObj, 124545)
              let jsonStrObj1 = JsonSpj
              console.log(jsonStrObj1, 124545)

              const sortedTestCases = {};
              this.tableData1.forEach((item, index) => {
                const key = index + 1;
                const originalKey = Object.keys(jsonStrObj1.test_cases).find(k => jsonStrObj1.test_cases[k].input_name === item.input_name);
                sortedTestCases[key] = jsonStrObj1.test_cases[originalKey];
              });
              // 更新obj对象
              jsonStrObj1.test_cases = sortedTestCases;
              console.log(jsonStrObj1, 124545)
              let jsonStrObj2 = JSON.stringify(jsonStrObj1)
              uploadFileBlob(
                Buffer.from(jsonStrObj2),
                "problem/" + this.problem_testcase_id + "/" + 'info',
                function (res) {
                  console.log(res, "上传info文件");
                }
              );
              adminAddOrUpdateOjProblem({
                id: this.difficultyId,
                attachment_url: this.problem.attachment_url,

                spj_version: this.spjVersion,
                md_description: this.problem.markdown_explain,
                md_input_description: this.problem.md_input_description,
                md_output_description: this.problem.md_output_description,
                md_hint: this.problem.md_hint,
                description_show_type: this.value1,


                test_case_score: JSON.stringify(this.tableData1),
                // test_case_score: JSON.stringify(this.problem.test_case_score),
                test_case_id: this.problem_testcase_id,

                total_score: this.problem.total_score,
                spj: this.spj,
                visible: this.problem.visible,
                languages: JSON.stringify(this.problem.languages),
                samples: JSON.stringify(this.problem.samples),
                description: this.problem.description,
                input_description: this.problem.input_description,
                output_description: this.problem.output_description,
                hint: this.problem.hint,
                sort_num: this.problem.sort_num,
                code: this.problem.code,
                title: this.problem.title,
                time_limit: this.problem.time_limit,
                memory_limit: this.problem.memory_limit,
                oj_problem_difficulty_id: this.problem.oj_problem_difficulty_id,
                difficulty: this.problem.difficulty,
                oj_problem_source_id: this.problem.oj_problem_source_id,
                tagIdArr: JSON.stringify(this.problem.tagIdArr),
                rule_type: this.problem.rule_type,
                io_mode: this.problem.io_mode,
                share_submission: this.problem.share_submission,
                is_public: this.problem.is_public,

                spj_code: this.problem.spj_code,
                spj_language: this.problem.spj_language,
                // spj: this.problem.spj1,
                // template: JSON.stringify(obj),
                template: JSON.stringify(this.template1),

              }).then((res) => {
                console.log(res, 33321);
                this.goback();
              });
            } else {
              console.log(this.jsonStrObj, 124545)
              let jsonStrObj1 = JSON.parse(this.jsonStrObj)
              console.log(jsonStrObj1, 124545)

              const sortedTestCases = {};
              this.tableData1.forEach((item, index) => {
                const key = index + 1;
                const originalKey = Object.keys(jsonStrObj1.test_cases).find(k => jsonStrObj1.test_cases[k].input_name === item.input_name);
                sortedTestCases[key] = jsonStrObj1.test_cases[originalKey];
              });
              // 更新obj对象
              jsonStrObj1.test_cases = sortedTestCases;
              console.log(jsonStrObj1, 124545)
              let jsonStrObj2 = JSON.stringify(jsonStrObj1)
              uploadFileBlob(
                Buffer.from(jsonStrObj2),
                "problem/" + this.problem_testcase_id + "/" + 'info',
                function (res) {
                  console.log(res, "上传info文件");
                }
              );
              adminAddOrUpdateOjProblem({
                id: '',
                description_show_type: this.value1,
                attachment_url: this.problem.attachment_url,

                md_description: this.problem.markdown_explain,
                md_input_description: this.problem.md_input_description,
                md_output_description: this.problem.md_output_description,
                md_hint: this.problem.md_hint,
                spj_version: this.spjVersion,
                test_case_score: JSON.stringify(this.problem.test_case_score),


                // test_case_id: this.problem_testcase_id,
                test_case_id: this.problem_testcase_id,

                total_score: this.problem.total_score,
                spj: this.spj,
                visible: this.problem.visible,
                languages: JSON.stringify(this.problem.languages),
                samples: JSON.stringify(this.problem.samples),
                description: this.problem.description,
                input_description: this.problem.input_description,
                output_description: this.problem.output_description,
                hint: this.problem.hint,
                sort_num: this.problem.sort_num,
                code: this.problem.code,
                title: this.problem.title,
                time_limit: this.problem.time_limit,
                memory_limit: this.problem.memory_limit,
                oj_problem_difficulty_id: this.problem.oj_problem_difficulty_id,
                difficulty: this.problem.difficulty,
                oj_problem_source_id: this.problem.oj_problem_source_id,
                tagIdArr: JSON.stringify(this.problem.tagIdArr),
                rule_type: this.problem.rule_type,
                io_mode: this.problem.io_mode,
                share_submission: this.problem.share_submission,
                is_public: this.problem.is_public,
                spj_code: this.problem.spj_code,
                spj_language: this.problem.spj_language,
                // template: JSON.stringify(obj),
                template: JSON.stringify(this.template1),

                contest_id: this.contest_id,
              }).then((res) => {
                console.log(res, 33321);
                adminAddProblemForContest({
                  contest_id: this.contest_id,
                  problemIds: JSON.stringify([res.ojProblemId]),
                }).then(() => {
                  this.$message.success("填加成功！！");
                  this.goback();
                });
              });
            }
          }
        });
      }

    },


    save(formName) {

      if (this.tableData1.length === 0) {
        this.$message.warning('测试用例不能为空')
        return false
      } else {

        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.difficultyId) {
              let JsonSpj = {}
              var test_cases = {};

              var spj = this.spj === '0' ? false : true;

              this.tableData1.map((item, index) => {
                test_cases[index + 1] = item
              })
              JsonSpj.spj = spj
              JsonSpj.test_cases = test_cases

              console.log(JsonSpj, 124545)
              console.log(this.jsonStrObj, 124545)
              let jsonStrObj1 = JsonSpj
              console.log(jsonStrObj1, 124545)

              const sortedTestCases = {};
              this.tableData1.forEach((item, index) => {
                const key = index + 1;
                const originalKey = Object.keys(jsonStrObj1.test_cases).find(k => jsonStrObj1.test_cases[k].input_name === item.input_name);
                sortedTestCases[key] = jsonStrObj1.test_cases[originalKey];
              });
              // 更新obj对象
              jsonStrObj1.test_cases = sortedTestCases;
              console.log(jsonStrObj1, 124545)
              let jsonStrObj2 = JSON.stringify(jsonStrObj1)
              uploadFileBlob(
                Buffer.from(jsonStrObj2),
                "problem/" + this.problem_testcase_id + "/" + 'info',
                function (res) {
                  console.log(res, "上传info文件");
                }
              );
              adminAddOrUpdateOjProblem({
                id: this.difficultyId,
                attachment_url: this.problem.attachment_url,

                description_show_type: this.value1,
                md_description: this.problem.markdown_explain,
                md_input_description: this.problem.md_input_description,
                md_output_description: this.problem.md_output_description,
                md_hint: this.problem.md_hint,

                spj_version: this.spjVersion,
                test_case_score: JSON.stringify(this.tableData1),


                // test_case_score: this.problem.test_case_score,
                test_case_id: this.problem_testcase_id,
                total_score: this.problem.total_score,
                spj: this.spj,
                visible: this.problem.visible,
                languages: JSON.stringify(this.problem.languages),
                samples: JSON.stringify(this.problem.samples),
                description: this.problem.description,
                input_description: this.problem.input_description,
                output_description: this.problem.output_description,
                hint: this.problem.hint,
                sort_num: this.problem.sort_num,
                code: this.problem.code,
                title: this.problem.title,
                time_limit: this.problem.time_limit,
                memory_limit: this.problem.memory_limit,
                oj_problem_difficulty_id: this.problem.oj_problem_difficulty_id,
                difficulty: this.problem.difficulty,
                oj_problem_source_id: this.problem.oj_problem_source_id,
                tagIdArr: JSON.stringify(this.problem.tagIdArr),
                rule_type: this.problem.rule_type,
                io_mode: this.problem.io_mode,
                share_submission: this.problem.share_submission,
                is_public: this.problem.is_public,

                spj_code: this.problem.spj_code,
                spj_language: this.problem.spj_language,
                // spj: this.problem.spj1,
                template: JSON.stringify(this.template1),
              }).then((res) => {
                console.log(res, 33321);
                this.goback();
              });
            } else {
              console.log(this.jsonStrObj, 124545)
              let jsonStrObj1 = JSON.parse(this.jsonStrObj)
              console.log(jsonStrObj1, 124545)

              const sortedTestCases = {};
              this.tableData1.forEach((item, index) => {
                const key = index + 1;
                const originalKey = Object.keys(jsonStrObj1.test_cases).find(k => jsonStrObj1.test_cases[k].input_name === item.input_name);
                sortedTestCases[key] = jsonStrObj1.test_cases[originalKey];
              });
              // 更新obj对象
              jsonStrObj1.test_cases = sortedTestCases;
              console.log(jsonStrObj1, 124545)
              let jsonStrObj2 = JSON.stringify(jsonStrObj1)
              uploadFileBlob(
                Buffer.from(jsonStrObj2),
                "problem/" + this.problem_testcase_id + "/" + 'info',
                function (res) {
                  console.log(res, "上传info文件");
                }
              );
              adminAddOrUpdateOjProblem({
                id: '',
                attachment_url: this.problem.attachment_url,

                description_show_type: this.value1,

                md_description: this.problem.markdown_explain,
                md_input_description: this.problem.md_input_description,
                md_output_description: this.problem.md_output_description,
                md_hint: this.problem.md_hint,
                spj_version: this.spjVersion,
                test_case_score: JSON.stringify(this.problem.test_case_score),
                test_case_id: this.problem_testcase_id,
                total_score: this.problem.total_score,
                spj: this.spj,
                visible: this.problem.visible,
                languages: JSON.stringify(this.problem.languages),
                samples: JSON.stringify(this.problem.samples),

                description: this.problem.description,
                input_description: this.problem.input_description,
                output_description: this.problem.output_description,
                hint: this.problem.hint,
                sort_num: this.problem.sort_num,
                code: this.problem.code,
                title: this.problem.title,
                time_limit: this.problem.time_limit,
                memory_limit: this.problem.memory_limit,
                oj_problem_difficulty_id: this.problem.oj_problem_difficulty_id,
                difficulty: this.problem.difficulty,
                oj_problem_source_id: this.problem.oj_problem_source_id,
                tagIdArr: JSON.stringify(this.problem.tagIdArr),
                rule_type: this.problem.rule_type,
                io_mode: this.problem.io_mode,
                share_submission: this.problem.share_submission,
                is_public: this.problem.is_public,

                spj_code: this.problem.spj_code,
                spj_language: this.problem.spj_language,
                // spj: this.problem.spj1,
                template: JSON.stringify(this.template1),
                // ...this.problem,
                // spj: this.spj,
                // template: JSON.stringify(this.codeTemplate),
              }).then((res) => {
                console.log(res, 33321);

                this.goback();
              });
            }
          }
        });
      }

    },
    //获取来源标签
    adminGetOjProblemSourceList() {
      adminGetOjProblemSourceList({
        page_no: 1,
        page_size: 500,
      }).then((res) => {
        console.log(res, 45);
        this.problemList = res.ojProblemSourceList;
      });
    },
    //获取算法标签
    adminGetOjProblemTagList() {
      adminGetOjProblemTagList({
        page_no: 1,
        page_size: 500,
      }).then((res) => {
        console.log(res, 7787);
        // tableData3
        this.tagIdArrList = res.ojProblemTagList;
      });
    },
    arrayBufferToBase64(buffer) {
      let binary = "";
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i += 1) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary); //base64
    },

    // 验证文件格式是否正确
    beforeAvatarUpload(file) {
      let isFile =
        file.name.split(".")[file.name.split(".").length - 1] == "zip";
      if (!isFile) {
        this.$message.error("导入文件格式不正确");
      }
      return isFile;
    },

    // 读取压缩文件
    async uploadFile(file) {
      this.tableData1 = []
      await uploadFileBlob('', '', '', true)
      console.log('重新上传测试用例,更新ID')
      this.problem_testcase_id = uuid.v1();

      var problem_info = {}; //测试用例数组
      var problem_case; //单测试点
      var test_cases = {};
      var problem_case_arr = []// 测试点组合
      var problem_in_num = 0;
      var problem_out_num = 0;
      var spj = this.spj === '0' ? false : true;

      var that = this;
      //上传压缩包的输入输出文件
      JSZip.loadAsync(file.file).then(function (zip) {

        zip.forEach(function (relativePath, zipEntry) {

          //忽略MAC路径
          if (zipEntry.name.indexOf("__MACOSX/._") > -1) {
            console.log('检测到mac路径')
            return;
          }
          //寻找输入点
          if (zipEntry.name.split('.')[1] === 'in') {

            problem_in_num++; //记录输入点数量
            //寻找输入点对应的输出点
            zip.forEach(function (relativePath_1, zipEntry_1) {

              if (zipEntry_1.name.split('.')[1] === 'out') {
                if (zipEntry_1.name.split('.')[0] === zipEntry.name.split('.')[0]) {
                  //读取对应输出点内容
                  zipEntry_1.async('string').then((res) => {
                    problem_out_num++; //记录输入点数量
                    problem_case = {};//单测试点数据
                    problem_case.input_name = zipEntry.name;
                    problem_case.output_name = zipEntry.name.split('.')[0] + '.out';


                    var lines = res.split('\n');
                    console.log(lines, 123456777)

                    for (let i = 0; i < lines.length; i++) {
                      lines[i] = lines[i].trimEnd();
                    }

                    problem_case.stripped_output_md5 = md5(lines.join('\n').trimEnd());
                    problem_case_arr.push(problem_case); //测试点组合

                    //等待文件扫描完成
                    if (problem_out_num === problem_in_num) {

                      for (let i = 0; i < problem_case_arr.length; i++) {
                        test_cases[i + 1] = problem_case_arr[i];

                        that.tableData1 = problem_case_arr;
                        that.problem.test_case_score = problem_case_arr;
                        that.tableData1[i].score = that.num;

                      }
                      console.log(that.tableData1, 123456789)
                      that.tableData1.sort((a, b) => {
                        if (a.input_name < b.input_name) {
                          return -1;
                        }
                        if (a.input_name > b.input_name) {
                          return 1;
                        }
                        return 0;
                      });
                      console.log(that.tableData1, 12457848);
                      //组合测试点info
                      problem_info.spj = spj;
                      problem_info.test_cases = test_cases;

                      //上传problem_info 文件
                      var jsonStr = JSON.stringify(problem_info);
                      console.log(jsonStr, 12345111)

                      that.jsonStrObj = jsonStr
                      console.log(that.jsonStrObj, 12345111)


                    }
                  })
                }
              }
            })
          }


          //上传测试用例文件
          zipEntry.async("base64").then(function (res) {
            console.log(res, 1236456)
            // that.base64File = res
            // that.zipEntryName = zipEntry.name
            uploadFileBlob(
              Buffer.from(res, "base64"),
              "problem/" + that.problem_testcase_id + "/" + zipEntry.name,
              function (res) {
                console.log(res, '上传测试用例文件');
                that.isdrag = true
              }
            );
          });
        });
      })

    },

    handleRemove(file, fileList) {
      console.log(file, 123456);
      console.log(fileList, 123456);

      this.tableData1 = [];
      this.fileList = [];
    },
    handleExceed() {
      this.$message.warning("请删除原有文件,再重新上传");
    },
    goback() {
      this.$router.go(-1);
    },
    spjBtn(val) {
      console.log(val, 456);
      if (val === true) {
        this.spj = "1";
      } else {
        this.spj = "0";
      }
      this.isShow = val;
    },
    addSample() {
      this.problem.samples.push({ input: "", output: "" });
    },
    deleteSample(index) {
      this.problem.samples.splice(index, 1);
    },
    //选择语言
    languagesChange(val) {
      console.log(val);
    },
    //选择标签
    handleClose(tag) {
      this.problem.dynamicTags.splice(this.problem.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.problem.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>
<style>
.ghostClass {
  background: #d9dee4 !important;
}

.chosenClass:hover > td {
  background: #d9dee4 !important;
}
</style>
<style lang="scss" scoped>
.subject {
  height: 100%;
  width: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  cursor: pointer;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.table {
  margin: 10px;
  background: 10px;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.add-samples {
  width: 100%;
  background-color: #fff;
  border: 1px dashed #aaa;
  outline: none;
  cursor: pointer;
  color: #666;
  height: 35px;
  font-size: 14px;

  &:hover {
    background-color: #f9fafc;
  }

  i {
    margin-right: 10px;
  }
}

.add-sample-btn {
  margin-bottom: 10px;
}

/deep/ .mce-statusbar > .mce-container-body {
  display: none;
}
</style>